import styled from 'styled-components';

export const PageContainer = styled.div`
  width: 100%;
  height: 100%;

  position: relative;
  padding-top: 104px;

  background-color: ${({ theme }) => theme.colors.greys.lighter};
`;

export const ListViewContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;

  position: relative;
`;

export const NameText = styled.div`
  word-break: break-word;

  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const ModalListViewContainer = styled.div`
  width: 100%;
  height: 100%;

  display: flex;

  position: relative;
`;
